import React, { FC } from 'react';
import VendorSuccessImg from 'assets/images/vendor-success.webp';
import ResolveImage from 'components/ResolveImage/ResolveImage.component';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PluscircleIcon from 'icons/Pluscircle.icon';
import {
  CREATE_DEAL_ROUTE,
  SELLING_PORTFOLIO_ROUTE,
  DOCUMENT_FILES,
} from 'data/global';
import { DropzoneFile } from 'components/Dropzone/utils';
import useUploadIm, { LISTING_IM } from 'hooks/useUploadIm';
import Dropzone from 'components/Dropzone';
import utils from 'utils';
import classNames from 'classnames';

import './UploadImSuccessful.styles.scss';
import './UploadImSuccessful.styles.responsive.scss';

export type UploadImSuccessfulProps = {
  className?: string;
  dealRoomId?: string;
  listingIM?: DropzoneFile;
  listingUrl?: string;
  updateListingIm?: (listingIm: DropzoneFile) => void;
};

const UploadImSuccessful: FC<UploadImSuccessfulProps> = (props) => {
  const { className, listingIM, listingUrl, dealRoomId, updateListingIm } =
    props;

  const { uploadListingIm } = useUploadIm(dealRoomId, updateListingIm);

  const { t } = useTranslation();

  const classes = classNames('upload-im-successful', className);

  return (
    <div className={classes}>
      <ResolveImage src={VendorSuccessImg} />

      {listingIM ? (
        <>
          <p className="upload-im-successful__subtitle">
            {t('yourImUploadWasSuccessful')}
          </p>
          <Dropzone
            fileName={LISTING_IM}
            accept={DOCUMENT_FILES}
            files={[listingIM]}
            maxFiles={1}
            replaceFile
            showApplicationAsIframe
            uploadRequest={uploadListingIm}
            deleteRequest={utils.noop}
          />
          <p>{t('changedYourMind')}</p>
        </>
      ) : (
        <>
          <h1>{t('IMUploadSuccessful')}</h1>
          <p>{t('weWillDraftYourListing')}</p>
        </>
      )}

      <div className="upload-im-successful__actions">
        <Link
          to={listingUrl || CREATE_DEAL_ROUTE}
          className="ncoded-button ncoded-button--solid"
          replace
        >
          {listingUrl ? (
            t('createAListingManually')
          ) : (
            <>
              <PluscircleIcon />
              {t('addAnotherDeal')}
            </>
          )}
        </Link>
        <Link
          to={SELLING_PORTFOLIO_ROUTE}
          className="ncoded-button ncoded-button--outline"
          replace
        >
          {t('goToYourPortfolio')}
        </Link>
      </div>
    </div>
  );
};

export default UploadImSuccessful;
